import GlobalStyles from '@mui/material/GlobalStyles';
// @mui
import { useTheme } from '@mui/material/styles';

const StyledProgressBar = () => {
  const theme = useTheme();

  const inputGlobalStyles = (
    <GlobalStyles
      styles={{
        '#nprogress': {
          '.bar': {
            backgroundColor: theme.palette.primary.main,
            boxShadow: `0 0 2px ${theme.palette.primary.main}`,
            height: 2,
            left: 0,
            position: 'fixed',
            top: 0,
            width: '100%',
            zIndex: 9999,
          },
          '.peg': {
            boxShadow: `0 0 10px ${theme.palette.primary.main}, 0 0 5px ${theme.palette.primary.main}`,
            display: 'block',
            height: '100%',
            opacity: 1,
            position: 'absolute',
            right: 0,
            transform: 'rotate(3deg) translate(0px, -4px)',
            width: 100,
          },
          pointerEvents: 'none',
        },
      }}
    />
  );

  return inputGlobalStyles;
};

export default StyledProgressBar;
